import { Box } from '@mui/material';
import React, { useState } from 'react';
import { SystemAlert } from '../../../model/reporting/systemAlert';
import { getReportingSystemAlerts } from '../../../redux/actions/reportingActions';
import { useAppThunkDispatch } from '../../../redux/configureStore';
import ShowSystemAlertDetailDialog from '../Dialog/ShowSystemAlertDetailDialog';
import AdminMonitoringHeader from './AdminMonitoringHeader';
import SystemAlertsTable from './SystemAlertsTable/SystemAlertsTable';

export const AdminMonitoringPage: React.FC = () => {
  const dispatch = useAppThunkDispatch();
  const [selectedAlert, setSelectedAlert] = useState<SystemAlert | null>(null);
  const [isAlertsLoading, setIsAlertsLoading] = useState(false);
  const [isDalogOpen, setIsDialogOpen] = React.useState<boolean>(false);

  const toggleDialog = () => {
    setIsDialogOpen((prevState) => !prevState);
  };

  const handleAlertSelect = (alert: SystemAlert) => {
    setSelectedAlert(alert);
    setIsDialogOpen((prevState) => !prevState);
  };

  const handleRefreshSystemAlerts = () => {
    setIsAlertsLoading(true);

    dispatch(getReportingSystemAlerts()).then((response: any) => {
      setIsAlertsLoading(false);
    });
  };

  return (
    <Box sx={{ mr: 10 }}>
      <AdminMonitoringHeader
        onRefreshAdminMonitoring={handleRefreshSystemAlerts}
      />
      <SystemAlertsTable
        isLoading={isAlertsLoading}
        onSelectAlert={handleAlertSelect}
      />
      <ShowSystemAlertDetailDialog
        isAddCompliancePeriodOpen={isDalogOpen}
        handleDialogClose={toggleDialog}
        alert={selectedAlert}
      />
    </Box>
  );
};

export default AdminMonitoringPage;
